var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    fill: "#4D7FAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7087 41.1667C42.7087 35.4922 47.3258 30.875 53.0003 30.875C58.6748 30.875 63.292 35.4922 63.292 41.1667C63.292 46.8412 58.6748 51.4583 53.0003 51.4583C47.3258 51.4583 42.7087 46.8412 42.7087 41.1667ZM59.5003 54.7083H46.5003C39.632 54.7083 34.042 60.2983 34.042 67.1667C34.042 70.4535 36.7135 73.125 40.0003 73.125H66.0003C69.2872 73.125 71.9587 70.4535 71.9587 67.1667C71.9587 60.2983 66.3687 54.7083 59.5003 54.7083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile1);
export default __webpack_public_path__ + "static/media/UserProfile1.457a72f3e61cb73a0c82692e3ce0b456.svg";
export { ForwardRef as ReactComponent };